import { memoize } from 'util/memoization'
import { connect } from 'react-redux'
import { selectRatingHistoryGauge } from 'ducks/reports/gauges'

import { TableVisualization } from 'ducks/reports/visualizations'

function onRatingFilterChange(evt, value) {
  return {
    query: {
      page: 1,
      grade: value,
    },
    filter: {
      grade: value,
    },
  }
}

// function onStatusFilterChange(evt, value) {
//   return {
//     query: {
//       page: 1,
//       ticket_state: value,
//     },
//     filter: {
//       ticket_state: value,
//     },
//   }
// }

function onPageSizeChange(evt, value) {
  return {
    query: {
      page: 1,
      per_page: value,
    },
  }
}

function onPageChange(evt, value) {
  return {
    query: {
      page: value,
    },
  }
}
// function onSortChange(evt, value) {
//   return {
//     query: {
//       page: 1,
//       order: value,
//     },
//     sort: {
//       order: value,
//     },
//   }
// }

const getColumnConfig = memoize((hasAgentId, excludeAgentColumn) => {
  const columns = [
    {
      header: 'Conversation subject',
      accessor: 'subject',
      component: TableVisualization.ConversationCell,
      sort: {
        accessor: 'created_at',
        type: 'number',
      },
    },
    {
      header: 'Customer',
      accessor: 'customer',
      component: TableVisualization.CustomerCell,
    },
    !excludeAgentColumn && {
      header: app.t('Agent'),
      accessor: 'agent_id',
      component: TableVisualization.AgentCell,
    },
    {
      header: 'Status',
      accessor: 'ticket_state',
      component: TableVisualization.ColorStatusCell,
    },
    {
      header: 'Initial Response',
      accessor: 'initial_response_time',
      component: TableVisualization.CountDownCell,
    },
    {
      header: 'Resolution Time',
      accessor: 'resolution_time',
      component: TableVisualization.CountDownCell,
    },
    {
      header: 'Rating',
      accessor: 'grade_int',
      component: TableVisualization.GradeToEmojiCell,
    },
  ].filter(x => !!x)

  if (hasAgentId) {
    columns.splice(2, 1)
  }

  return columns
})

function createRatingFilter() {
  return {
    accessor: 'grade',
    options: [
      {
        label: 'All',
        value: null,
      },
      {
        label: '😁',
        value: 0,
      },
      {
        label: '😕',
        value: 1,
      },
      {
        label: '😩',
        value: 2,
      },
    ],
    onClick: onRatingFilterChange,
  }
}

// function createStatusFilter() {
//   return {
//     accessor: 'ticket_state',
//     options: [
//       {
//         label: 'All',
//         value: null,
//       },
//       {
//         label: 'UNREAD',
//         value: '1000',
//       },
//       {
//         label: 'OPEN',
//         value: '2000,4000',
//       },
//       {
//         label: 'CLOSED',
//         value: '5000',
//       },
//       {
//         label: 'SNOOZED',
//         value: '3000',
//       },
//     ],
//     onClick: onStatusFilterChange,
//   }
// }

const createFilter = memoize(() => {
  // TODO: Re-add the status filter once we've corrected the table
  // to load all conversations instead of just rated conversations
  // if (filter === 'rating') {
  return createRatingFilter()
  // }
  // return createStatusFilter()
})

const paging = {
  visible: true,
  onPageSizeChange,
  onPageChange,
}
// const sort = {
//   onSortChange,
// }
const select = (state, props) => {
  return {
    gauge: selectRatingHistoryGauge(state, props),
    key: 'rating-history-table',
    title: props.title !== false ? props.title || 'Conversations' : null,
    subtitle:
      props.subtitle !== false
        ? props.subtitle ||
          'A list of all recent ratings over the selected period'
        : null,
    perPage: 10,
    page: 1,
    showPageSize: false,
    showPaging: false,
    filter: createFilter(props.filter),
    paging,
    // TODO: Re-think sorting on this table as it doesnt really add
    // much value atm
    sort: {},
    columns: getColumnConfig(
      !!props.queryBase.agent_id,
      props.excludeAgentColumn
    ),
  }
}
export default connect(select)(TableVisualization)
